import React, { useState } from "react";
import {
  Box,
  Button,
  Container,
  TextField,
  Typography,
  Alert,
  Snackbar,
  Avatar,
} from "@mui/material";
import MailOutlineIcon from "@mui/icons-material/MailOutline";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [errors, setErrors] = useState({});
  const [snackbar, setSnackbar] = useState(false);

  const validate = () => {
    const e = {};
    if (!form.name.trim()) e.name = "El nombre es requerido";
    if (!form.email.trim()) e.email = "El email es requerido";
    else if (!/\S+@\S+\.\S+/.test(form.email)) e.email = "Email inválido";
    if (!form.message.trim()) e.message = "El mensaje es requerido";
    return e;
  };

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    if (errors[e.target.name]) setErrors((prev) => ({ ...prev, [e.target.name]: "" }));
  };

  const handleSubmit = () => {
    const e = validate();
    if (Object.keys(e).length > 0) { setErrors(e); return; }
    setForm({ name: "", email: "", message: "" });
    setSnackbar(true);
  };

  return (
    <Container maxWidth="sm" sx={{ py: 8 }}>
      <Box sx={{ textAlign: "center", mb: 5 }}>
        <Avatar sx={{ bgcolor: "secondary.main", width: 64, height: 64, mx: "auto", mb: 2 }}>
          <MailOutlineIcon fontSize="large" />
        </Avatar>
        <Typography variant="h3" fontWeight={800} mb={1}>
          Contáctanos
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Envíanos un mensaje y te responderemos pronto.
        </Typography>
      </Box>

      <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
        <TextField
          label="Nombre"
          name="name"
          value={form.name}
          onChange={handleChange}
          error={!!errors.name}
          helperText={errors.name}
          fullWidth
        />
        <TextField
          label="Email"
          name="email"
          type="email"
          value={form.email}
          onChange={handleChange}
          error={!!errors.email}
          helperText={errors.email}
          fullWidth
        />
        <TextField
          label="Mensaje"
          name="message"
          multiline
          rows={5}
          value={form.message}
          onChange={handleChange}
          error={!!errors.message}
          helperText={errors.message}
          fullWidth
        />
        <Button variant="contained" size="large" onClick={handleSubmit} fullWidth>
          Enviar mensaje
        </Button>
      </Box>

      <Snackbar
        open={snackbar}
        autoHideDuration={4000}
        onClose={() => setSnackbar(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert severity="success" onClose={() => setSnackbar(false)} sx={{ width: "100%" }}>
          ¡Mensaje enviado correctamente!
        </Alert>
      </Snackbar>
    </Container>
  );
}
